import Table from "../../components/table/Table";

export default function SheetCell(props) {
  return (
    <Table.Cell
      {...props}
      className={
        "lg:p-0 p-0 text-center border border-tenken-gray-500 whitespace-nowrap " +
        props.className
      }
    >
      {props.children}
    </Table.Cell>
  );
}
